import { MIN_HOLDOVER_PERCENT, MAX_HOLDOVER_PERCENT } from './constants';

export function validateHoldoverPercentLimits(value: any) {
  const numValue = Number(value);

  return numValue >= MIN_HOLDOVER_PERCENT && numValue <= MAX_HOLDOVER_PERCENT
    ? undefined
    : `Must be between ${MIN_HOLDOVER_PERCENT} and ${MAX_HOLDOVER_PERCENT}.`;
}
